/**
 * Automy.Core.Enums.Reporting.ReportingStreamHealthStatus
 * JSON `health` on dataset ops items (string token). Omitted when there is no stream.
 */
export default Object.freeze({
  Healthy: 'healthy',
  Lagging: 'lagging',
  ReconciliationPending: 'reconciliation-pending',
  AntiEntropyOverdue: 'anti-entropy-overdue',
  Failed: 'failed',
  RebuildRequired: 'rebuild-required',
});
